// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (max-width:460px){.card-scroller__items .card{max-width:85vw;min-width:85vw}.card-scroller__items .card .card__image{max-height:130px}.card-scroller__items .card .card__bottom .bottom-content{overflow:auto}}.card-scroller__items .card:not(:last-of-type){margin-right:20px}*{-webkit-box-sizing:inherit;box-sizing:inherit}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
